// extracted by mini-css-extract-plugin
export default {"heading":"Winback-module__heading__v5aFD","heading-text":"Winback-module__heading-text__A0Lk9"};